import I18n from 'I18n';
import UISelect from 'UIComponents/input/UISelect';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { usePaymentAndRefundEmailOptions } from '../../../hooks/usePaymentAndRefundEmailOptions';
import { jsx as _jsx } from "react/jsx-runtime";
const EmailSelectInput = ({
  objectId,
  value,
  onChange
}) => {
  const paymentAndRefundEmailOptions = usePaymentAndRefundEmailOptions(objectId);
  return /*#__PURE__*/_jsx(FormControl, {
    label: I18n.text('cardPaymentHighlight.paymentHighlight.sidebarActions.sendEmail.chooseReceipt'),
    children: /*#__PURE__*/_jsx(UISelect, {
      onChange: onChange,
      options: paymentAndRefundEmailOptions,
      value: value,
      "data-test-id": "email-select-input"
    })
  });
};
export default EmailSelectInput;